import MarqueeLib from "react-fast-marquee";
import { Asterisk } from "@phosphor-icons/react";

const words = [
  "Workout",
  "Fuel",
  "Focus",
  "Repeat",
  "Strong Body",
  "Unstoppable Mind",
  "Be Strong",
  "Be Fierce",
  "Be You",
];

export default function Marquee() {
  return (
    <section data-testid="marquee-band" className="bg-[#FF1B91] border-y border-black/20 py-5 overflow-hidden">
      <MarqueeLib gradient={false} speed={60} pauseOnHover={false}>
        {words.concat(words).map((w, i) => (
          <span
            key={i}
            className="font-display font-black uppercase text-3xl md:text-4xl tracking-tighter mx-8 inline-flex items-center gap-8 text-black"
          >
            {w}
            <Asterisk size={22} weight="bold" />
          </span>
        ))}
      </MarqueeLib>
    </section>
  );
}
